export const SECTOR_OPTIONS = [
  { label: "All Sectors", value: "all" },
  { label: "APAC FOODS", value: "APAC Foods" },
  { label: "CORPORATE", value: "Corporate" },
  { label: "EMEA FOODS", value: "EMEA Foods" },
  { label: "GLOBAL", value: "Global" },
  { label: "INTERNATIONAL BEVERAGES", value: "International Beverages" },
  { label: "LATAM FOODS", value: "LATAM Foods" },
  { label: "NORTH AMERICA", value: "North America" },
  { label: "NOT PROVIDED", value: "Not Provided" }
];

export const signedHappinessIndex = (value: number) => {
    if (Number.isNaN(value)) {
        return value;
    }

    if (value === 0) {
        return 0;
    }

    return new Intl.NumberFormat('en-US', {
        signDisplay: 'always',
    }).format(value);
};